import React from 'react'
import { IMaskInput } from 'react-imask';

const PhoneInput = React.forwardRef(function PhoneInput(props, ref) {
    const { onChange, style, className, ...other } = props;
    return (
        <IMaskInput
            {...other}
            mask="000-000-0000"
            definitions={{
                '#': /[1-9]/,
            }}
            inputRef={ref}
            onAccept={(value) => onChange && onChange({ target: { name: props.name, value } })}
            overwrite
            className={className}
            style={{
                border: 'none',
                outline: 'none',
                background: 'transparent',
                boxShadow: 'none',
                fontSize: '14px',
                width: '100%',
                ...style,
            }}
        />
    );
});

export default PhoneInput;

